<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>

    <div v-else class="px-2 px-md-0">
      <!-- Širina je sada 100% na mobilnim uređajima, a 80% na većim ekranima -->
      <div class="element-box mx-auto w-100 w-lg-80">

        <!-- KARTICA SA PODACIMA -->
        <div class="row m-0 p-3 p-md-4 bg-white rounded shadow-sm"
             :style="{
              'border': `1px solid ${company?.color} !important`,
              'border-top': `3px solid ${company?.color} !important`
              }">
          <div class="col-12">

            <!-- Zaglavlje sa logotipom i tajmerom (flex-column na mobilnom, row na desktopu) -->
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 pb-3 border-bottom gap-3">

              <h5 class="font-weight-bold text-secondary mb-2 mb-md-0 d-flex align-items-center">
                <i class="os-icon os-icon-user mr-2" :style="{ color: company?.color }"></i>
                <span>Benutzerdaten</span>
              </h5>

              <div class="text-center my-2 my-md-0">
                <div class="text-danger font-weight-bold pulse-animation small-mobile-text">
                  <i class="os-icon os-icon-clock mr-1"></i>Link gültig bis: {{ tokenExpiresAt || 'Keine Angaben' }}
                </div>
              </div>

              <div class="text-center text-md-right">
                <img :src="company?.logo" alt="Logo" class="img-fluid" style="max-height: 45px; object-fit: contain"/>
              </div>
            </div>

            <!-- Korisnički podaci -->
            <div class="row mb-3">
              <div class="col-12 col-md-6 mb-2">
                <small class="text-muted d-block text-uppercase font-weight-bold tracking-wider">
                  Vor- und Nachname
                </small>
                <span class="h5 font-weight-normal text-dark d-block mt-1">
                  {{ unemployed?.firstName }} {{ unemployed?.lastName }}
                </span>
              </div>
            </div>

            <!-- Coaching podaci -->
            <div class="border-top pt-3 mt-3">
              <h6 class="font-weight-bold text-secondary mb-3 d-flex align-items-center">
                <i class="os-icon os-icon-trending-up mr-2" :style="{ color: company?.color }"></i>
                <span>Coaching-Daten</span>
              </h6>

              <div class="row">
                <div class="col-6 col-sm-4 col-md-3 mb-3">
                  <small class="text-muted d-block text-uppercase font-weight-bold tracking-wider">Startdatum</small>
                  <span class="text-dark font-weight-medium"> {{ coaching?.startDate || 'Keine Angaben' }} </span>
                </div>
                <div class="col-6 col-sm-4 col-md-3 mb-3">
                  <small class="text-muted d-block text-uppercase font-weight-bold tracking-wider">Enddatum</small>
                  <span class="text-dark font-weight-medium"> {{ coaching?.endDate || 'Keine Angaben' }} </span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="table-responsive mt-4 rounded shadow-sm bg-white">
          <table class="table table-striped align-middle mb-0">
            <thead
                :style="{
                    borderBottom: `3px solid ${company?.color}`,
                    color: 'black'
                }"
            >
            <tr>
              <th class="py-3 px-2 text-nowrap" style="font-size: 12px">Termin</th>
              <th class="py-3 px-2 text-nowrap" style="font-size: 12px">Startzeit</th>
              <th class="py-3 px-2 text-nowrap" style="font-size: 12px">Endzeit</th>
              <th class="py-3 px-2 text-nowrap" style="font-size: 12px">Anwesenheit</th>
              <th class="text-right py-3 px-2 text-nowrap" style="font-size: 12px">Einheiten</th>
              <th class="text-center py-3 px-2 text-nowrap" style="font-size: 12px">Unterschrift</th>
              <th class="text-right py-3 px-2 text-nowrap" style="font-size: 12px">Aktion</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="meeting in meetings" :key="meeting.id">
              <td class="font-weight-bold align-middle text-nowrap">{{ meeting?.termin }}</td>
              <td class="align-middle text-nowrap">{{ meeting?.startTime }}</td>
              <td class="align-middle text-nowrap">{{ meeting?.endTime }}</td>
              <td class="align-middle text-nowrap">{{ meeting?.presenceTranslation }}</td>
              <td class="text-right align-middle text-nowrap">{{ meeting?.units }}</td>

              <!-- Potpis prilagođen za manje ekrane -->
              <td class="text-center align-middle">
                <template v-if="!meeting.digitalSignature">
                  <span class="badge bg-soft-danger text-danger p-2" style="font-size: 11px; white-space: normal;">
                    Fehlende Digitale Unterschrift
                  </span>
                </template>
                <template v-else>
                  <div class="signature-img-container">
                    <img :src="meeting.digitalSignature" alt="Unterschrift" class="img-fluid signature-img"/>
                  </div>
                </template>
              </td>

              <!-- Dugme uvek vidljivo bez prelivanja -->
              <td class="text-right align-middle text-nowrap">
                <button class="btn btn-primary btn-sm px-3 py-2 d-inline-flex align-items-center"
                        @click.stop="handleDigitalSignatureModal(
                            meeting?.id,
                            meeting.meetingType
                            )">
                  <i class="os-icon os-icon-edit mr-1"></i>
                  <span>Unterschreiben</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <!-- MODAL ZA POTPIS -->
      <Modal
          v-model="showDigitalSignatureModal"
          title="Digitale Unterschrift"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-md"
          :hide-footer="true"
          classFooter="justify-content-center">
        <RemoteDigitalSignatureForm
            :token="token"
            :meetingId="meetingId"
            :meetingType="meetingType"
            v-model:submitForm="submitForm" />
      </Modal>
    </div>
  </PageTemplate>
</template>

<style scoped>
/* Prilagođavanje širine kontejnera */
@media (min-width: 992px) {
  .w-lg-80 {
    width: 80% !important;
  }
}

/* Održavanje responzivnosti slike potpisa */
.signature-img-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-img {
  max-width: 180px;
  height: auto;
  max-height: 50px;
  object-fit: contain;
}

/* Stil za upozorenje kad nedostaje potpis */
.bg-soft-danger {
  background-color: #fde8e8;
  color: #cf1020;
  border-radius: 4px;
}

/* Prilagođavanje veličine fonta na mobilnim uređajima */
@media (max-width: 576px) {
  .small-mobile-text {
    font-size: 13px !important;
  }
}
</style>

<script setup lang="ts">
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import {onMounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';
import RemoteDigitalSignatureForm
  from "@/views/App/Portal/PrivateCoaching/RemoteDigitalSignature/RemoteDigitalSignatureForm.vue";

const route = useRoute();

const company = ref<ICompany | null>(null);
const unemployed = ref<IUnemployed | null>(null);
const coaching = ref<ICoaching | null>(null);
const meetings = ref<IMeeting[]>([])
const meetingId = ref<number | null>(null);
const meetingType = ref<string>("")

const tokenExpiresAt = ref('')
const isLoaded = ref(false);
const showDigitalSignatureModal = ref(false);
const submitForm = ref(false);
const token = route.params.token as string;



interface ICompany {
  color: string;
  logo: string,
}

interface IUnemployed {
  firstName: string;
  lastName: string,
  address: string,
  city: string,
  zip: string,
  aaNumber: string,
  insuranceNumber: string,
  email: string,
  phone: string,
}

interface ICalculatedUnits {
  unitsDone: number;
  maxUnits: number;
}

interface ICoaching {
  startDate: string;
  endDate: string;
  calculatedUnits: ICalculatedUnits | null;
}

export interface IMeeting {
  id: number;
  termin: string;
  startTime: string;
  endTime: string;
  presenceTranslation: string;
  units: number;
  moduleName: string;
  digitalSignature: string | null;
  homeVisit: boolean;
  meetingType: string;
  coach?: {
    fullName: string;
  };
}

watch(submitForm, () => {
  meetingId.value = null;
  showDigitalSignatureModal.value = false;
  getData();
});

async function getData() {
  try {
    const {data} = await portalPrivateCoachingService.getRemoteMeetings(token);
    coaching.value = data.data?.coaching
    unemployed.value = data.data?.unemployed
    company.value = data.data?.company
    tokenExpiresAt.value = data.data?.expiresAt
    meetings.value = data.data?.meetings
  } catch (error) {
    await ErrorToast(error);
  }
}

function handleDigitalSignatureModal(id: number, type: string) {
  CloseToast();
  meetingId.value = id;
  meetingType.value = type;
  showDigitalSignatureModal.value = true;
}

onMounted(async () => {
  await getData()
  isLoaded.value = true;
});
</script>

<style scoped>

.pulse-animation {
  animation: pulse-effect 2s infinite ease-in-out;
  display: inline-block;
}

@keyframes pulse-effect {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.03);
    opacity: 0.85;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (min-width: 992px) {
  .w-lg-80 {
    width: 80% !important;
  }
}

.signature-img-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-img {
  max-width: 180px;
  height: auto;
  max-height: 50px;
  object-fit: contain;
}

.bg-soft-danger {
  background-color: #fde8e8;
  color: #cf1020;
  border-radius: 4px;
}

@media (max-width: 576px) {
  .small-mobile-text {
    font-size: 13px !important;
  }
}
</style>